import styled from 'styled-components'
import { FlexContainer } from '~/components/Layout'
import { SwitchRoundIcon } from '~/components/icons'

export const StyledRateContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 18px;
  color: ${({ theme }) => theme.colors.textStrong};
  font-weight: 400;
  font-size: 13px;
  line-height: 18px;
`

export const StyledRateWrapper = styled(FlexContainer)`
  height: 18px;
`

export const StyledRateDetail = styled(FlexContainer)`
  .boldText {
    font-weight: 600;
    font-size: 13px;
    line-height: 18px;
    letter-spacing: 0.2px;
  }
`

export const SwitchIcon = styled(SwitchRoundIcon)`
  cursor: pointer;
`

export const StyledSearchContainer = styled.div`
  display: flex;
  align-items: center;
  height: 18px;

  span {
    font-size: 12px;
    font-weight: 400;
    line-height: 18px;
    color: ${({ theme }) => theme.colors.primary};
  }
`

export const StyledRoutingContainer = styled.div`
  position: relative;
  width: 18px;
  height: 18px;
  margin-right: 4px;
  overflow: hidden;
`
